import React from 'react'
import parser from 'react-html-parser'
export default function TestoSemplice(props){

    return parser(props.testo)

}